import React, { useEffect } from 'react';
import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem, Badge } from 'reactstrap';
import strings from '../../globalization';
import consts from '../../consts';
import {
  preferenceForm,
  comboTypes,
  preferenceFormReset
} from '../../redux/actions';

const Preferences = ({
  dropDownItemClick,
  addPreference,
  listId,
  onRemovePref,
  ...props
}) => {
  const dispatch = useDispatch();
  const { preferences, shouldLoadPref } = useSelector(
    ({ comboTypes, preferenceFormData }) => {
      const { success, info } = preferenceFormData.data;
      let shouldLoadPref = false;
      if (
        success &&
        (info === 'RecordSavedSuccessfully' ||
          info === 'RecordUpdatedSuccessfully' ||
          info === 'DeleteSuccess')
      ) {
        shouldLoadPref = true;
      }
      return { preferences: comboTypes.Preference || [], shouldLoadPref };
    }
  );
  useEffect(() => {
    if (shouldLoadPref) {
      loadPreference();
    }
  }, [shouldLoadPref]);
  const loadPreference = () => {
    dispatch(preferenceFormReset());
    dispatch(
      comboTypes({
        action: 'comboType',
        comboType: ['Preference']
      })
    );
  };
  const deletePreference = id => {
    dispatch(preferenceForm({ action: 'delete', _id: id }));
    onRemovePref();
  };
  return (
    preferences &&
    preferences
      .filter(
        item =>
          item.GridId === listId &&
          item.PrefName !== consts.AUTO_DEFAULT_PREFERENCE_NAME
      )
      .map((obj, index) => {
        return (
          <div style={{ display: 'flex' }} key={obj._id}>
            <DropdownItem
              style={{ flexBasis: '100%' }}
              disabled={false}
              key={obj._id}
              onClick={() => dropDownItemClick(obj)}
              toggle={false}
            >
              {obj.PrefName}{' '}
              {obj.IsDefault && (
                <Badge color="secondary">{strings.Default}</Badge>
              )}
            </DropdownItem>
            <DropdownItem
              style={{ padding: '2px 8px', flexBasis: '0.8em' }}
              onClick={() => addPreference(obj._id)}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </DropdownItem>
            <DropdownItem
              style={{ padding: '2px 8px', flexBasis: '0.8em' }}
              onClick={() => deletePreference(obj._id)}
            >
              <FontAwesomeIcon icon={faTrash} color="#dc3545" />
            </DropdownItem>
          </div>
        );
      })
  );
};

export default Preferences;
